import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { Component } from 'react';

// Forward console.* to native (Xcode) if Capacitor Console plugin is available
(() => {
  try {
    const cap: any = (globalThis as any).Capacitor;
    const nativeConsole = cap?.Plugins?.ConsoleBridge || cap?.Plugins?.Console;
    if (!nativeConsole) return;
    const levels: Array<keyof Console> = ['log', 'info', 'warn', 'error', 'debug'];
    levels.forEach((level) => {
      const original = (console as any)[level]?.bind(console);
      (console as any)[level] = (...args: any[]) => {
        try {
          const messages = args.map((a) => {
            try { return typeof a === 'string' ? a : JSON.stringify(a); } catch { return String(a); }
          });
          if (typeof (nativeConsole as any)[level] === 'function') {
            (nativeConsole as any)[level]({ messages });
          } else if (typeof (nativeConsole as any).log === 'function') {
            (nativeConsole as any).log({ messages: [`[${level.toUpperCase()}]`, ...messages] });
          }
        } catch {}
        if (original) original(...args);
      };
    });
  } catch {}
})();

// Error Boundary Component
class ErrorBoundary extends Component<{ children: React.ReactNode }, { hasError: boolean; error: Error | null }> {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): { hasError: boolean; error: Error } {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError && this.state.error) {
      const error = this.state.error as Error;
      return (
        <div className="flex justify-center items-center h-screen text-red-600">
          <div>
            <h1>Error: {error.message}</h1>
            <pre>{error.stack || 'No stack trace available'}</pre>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// Minimal deep link handler for email change success
(async () => {
  try {
    const { App: CapacitorApp } = await import('@capacitor/app');
    
    CapacitorApp.addListener('appUrlOpen', ({ url }) => {
      if (url.includes('email-change-success')) {
        // Set a flag to prevent auth redirects
        try {
          sessionStorage.setItem('deeplink_processing', '1');
          // Clear the flag after 10 seconds
          setTimeout(() => {
            sessionStorage.removeItem('deeplink_processing');
          }, 10000);
        } catch (e) {
          // Ignore sessionStorage errors
        }
        
        // Navigate to success page
        try {
          window.history.replaceState({}, '', '/email-change-success');
          window.location.href = '/email-change-success';
        } catch (e) {
          // Ignore navigation errors
        }
      }
    });
  } catch (e) {
    // Ignore Capacitor errors
  }
})();